import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from './i18n/en';
import de from './i18n/de';
import sv from './i18n/sv';
import { customerConfig } from './customerConfig';

const allTranslations: Record<string, any> = { en, de, sv };

const allLanguages: Record<string, string> = {
    en: 'English',
    de: 'German',
    sv: 'Swedish',
};

const supportedLocaleList = customerConfig.supportedLanguages.map(lang => ({
    locale: lang,
    name: allLanguages[lang] || lang,
}));

export const i18nProvider = polyglotI18nProvider(
    locale => allTranslations[locale] || allTranslations['en'],
    customerConfig.defaultLanguage,
    supportedLocaleList,
    { allowMissing: true }
);
